import { render, staticRenderFns } from "./AppAccordionItem.vue?vue&type=template&id=df9c9aba&scoped=true"
import script from "./AppAccordionItem.vue?vue&type=script&lang=js"
export * from "./AppAccordionItem.vue?vue&type=script&lang=js"
import style0 from "./AppAccordionItem.vue?vue&type=style&index=0&id=df9c9aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9c9aba",
  null
  
)

export default component.exports